import { Box, Container } from "@mui/material";
import { useFetchDetail, usePostDetail } from "@hooks/useFetchDetail";
import { useNavigate } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { useAddEditSupplier } from "../hooks/useAddEditSupplier";
import AnimationFadeIn from "@components/AnimationFadeIn";
import SupplierFormCst from "../SupplierFormCst";

const AddSupplier: React.FC = () => {
  const { t } = useTranslation(["suppliers-page"]);
  const navigate = useNavigate();

  const { columns, mutate } = useFetchDetail(
    ServicesURL.getSuppliers,
    undefined,
    PagesID["suppliers"],
  );

  const { columns: detailColumns } = useFetchDetail(
    ServicesURL.getSuppliers,
    undefined,
    PagesID["suppliers.details"],
  );

  const { trigger } = usePostDetail(ServicesURL.postSuppliers);

  const { onSubmit, openConfirmStatus, setOpenConfirmStatus } =
    useAddEditSupplier(trigger, mutate);

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-suppliers.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("add.hero-title")}
          description={t("add.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <SupplierFormCst
              row={{}}
              columns={columns}
              detailColumns={detailColumns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(-1);
              }}
            />
          </Box>
        )}

        <ModalConfirmsCst
          open={!!openConfirmStatus}
          title={t("outcome-item", { ns: "modal" })}
          description={t("outcome-item", { ns: "modal" })}
          onCallBackClosed={() => setOpenConfirmStatus(undefined)}
          status={openConfirmStatus}
        />
      </Container>
    </AnimationFadeIn>
  );
};

export default AddSupplier;
